import React, { useState } from "react";


const CompanyCard = ({
  bg,
  logo,
  name,
  name2,
  tagline,
  description,
  projectLogo,
  website,
  logoWidth,
  logoHeight,
  isComingSoon,
}) => {

  return (
    <div
      className="rounded-4 overflow-hidden mb-5 "
      style={{
        backgroundImage: `linear-gradient(rgba(22, 22, 22, 0.5), rgba(92, 91, 91, 0.5)), url(${bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "550px",
        maxWidth: "1180px",
        margin: "0 auto",
      }}
    >
      <div className="row align-items-center p-lg-5 p-3 p-md-4 text-white">

        <div className="col-12 col-lg-12 p-lg-5 p-3 p-md-4 rounded-4">

          <div className="d-flex align-items-center gap-3 mb-3 flex-wrap">
            <img
              src={logo}
              alt="logo"
              width={logoWidth || "70"}
              height={logoHeight || "85"}
              className="rounded p-1 img-fluid"
              style={{ height: "auto" }}
            />

            <div className="d-flex flex-column">
              <h3
                className="fw-bold text-white mb-0"
                style={{ fontSize: 'clamp(18px, 2.6vw, 28px)', lineHeight: '1.1' }}
              >
                {name}
              </h3>
              <h6
                className="fw-semibold text-white mb-0 mt-1"
                style={{ fontSize: 'clamp(12px, 1.2vw, 16px)', lineHeight: '1' }}
              >
                {name2}
              </h6>
            </div>
          </div>

          <h5
            className="fw-normal mb-3 text-white mt-3 mt-lg-4 text-[14px]"
            style={{ maxWidth: "100%" }}
          >
            {tagline}
          </h5>
          <p
            className="fw-semibold mt-3 mt-lg-4 "
            style={{ maxWidth: "500px", lineHeight: "1.4rem" }}
          >
            {description}
          </p>

          <div className="mt-4 d-flex align-items-center gap-2 flex-wrap">
            <span className="fw-bold">Projects:</span>

            <img
              src={projectLogo}
              alt="project logo"
              className="bg-light img-fluid"
              style={{
                width: "40px",
                height: "40px",
                objectFit: "contain",
                borderRadius: "19px",
                padding: "4px",
                background: "#fff",
              }}
            />
          </div>

          {isComingSoon ? (
            <a
              href="#"
              className="d-inline-block mt-3 fw-bold text-decoration-none"
              style={{ color: "#ff6a2a", cursor: "not-allowed" }}
            >
              Coming Soon →
            </a>
          ) : (
            <a
              href={website}
              target="_blank"
              rel="noopener noreferrer"
              className="d-inline-block mt-3 fw-bold text-decoration-none"
              style={{ color: "#ff6a2a" }}
            >
              Visit Now →
            </a>
          )}

        </div>

      </div>
    </div>
  );
};

export default function ViskoSection() {

  //  6 Companies Data
  const companies = [
    {
      id: 1,
      name: "Visko HR Private Limited",
      tagline: "Empowering People.Strengthening Organizations.",
      description:
        "Visko HR Private Limited delivers comprehensive human resource solutions that help organizations build strong, skilled, and future-ready teams. With a people-first approach, we connect the right talent with the right opportunity, ensuring sustainable business growth.",
      bg: "https://api.visko.group/public/assets/img/uploads/ticket-docs/1772089078_f36aaec1f8b0cbb93824.png",
      logo: "https://api.visko.group/public/assets/img/uploads/ticket-docs/1772084399_5446bb8090a50274ce17.png",
      logoWidth: "60",
      logoHeight: "60",
      projectLogo: "https://remarkhr.com/logo/remark-logo-1000.png",
      website: "https://viskohr.com/",
      isComingSoon: false,
    },
    {
      id: 2,
      name: "Visko Real Estate Private Limited",
      tagline: "Building Spaces That Create Value.",
      description:
        "Visko Real Estate Pvt. Ltd. focuses on developing and managing quality real estate projects with transparency, trust, and long-term value at the core. Every project reflects our commitment to excellence and responsible development.",
      bg: "https://api.visko.group/public/assets/img/uploads/ticket-docs/1772089129_f6f83411e0e4349c6709.png",
      logo: "https://api.visko.group/public/assets/img/uploads/ticket-docs/1772084399_5446bb8090a50274ce17.png",
      logoWidth: "60",
      logoHeight: "60",
      projectLogo: "https://api.visko.group/public/assets/img/uploads/ticket-docs/1775728050_5d45a905966cc5dd83a8.png",
      website: "https://viskorealestate.com/",
      isComingSoon: false,
    },
    {
      id: 3,
      name: "Visko E-Serve Private Limited",
      tagline: "Smart Services. Seamless Operations.",
      description:
        "Visko E-Serve Pvt. Ltd. provides reliable digital and business support services designed to simplify processes, enhance efficiency, and support scalable growth for modern enterprises.",
      bg: "https://api.visko.group/public/assets/img/uploads/ticket-docs/1772089266_8578593a9fe2a99a13fc.png",
      logo: "https://api.visko.group/public/assets/img/uploads/ticket-docs/1772084399_5446bb8090a50274ce17.png",
      logoWidth: "60",
      logoHeight: "60",
      projectLogo: "https://api.visko.group/public/assets/img/uploads/ticket-docs/1775212108_46bc8467f89c0cebadc9.png",
      website: "https://viskoeserve.in/",
      isComingSoon: false,
    },
    {
      id: 4,
      name: "Visko Real Estate LLC",
      name2: "(Dubai)",
      tagline: "Creating well-planned developments that balance design, trust, and long-term value.",
      description:
        "Visko Real Estate LLC develops and manages real estate projects focused on quality, transparency, and sustainable growth. Our presence in Dubai, UAE reflects a strategic expansion aligned with international real estate standards.",
      bg: "https://api.visko.group/public/assets/img/uploads/ticket-docs/1772089334_e375757ff4462054e6a5.png",
      logo: "https://api.visko.group/public/assets/img/uploads/ticket-docs/1767079710_638b89f1e84599189d51.webp",
      logoWidth: "80",
      logoHeight: "75",
      projectLogo: "https://api.visko.group/public/assets/img/uploads/ticket-docs/1767079710_638b89f1e84599189d51.webp",
      website: "https://viskorealestate.ae/",
      isComingSoon: false,
    },
    {
      id: 5,
      name: "Visko Textile Industries Private Limited",
      tagline: "Introducing elegance and luxury through a refined and thoughtful fashion approach.",
      description:
        "Visko Textile Pvt. Ltd. is a fashion brand focused on timeless design, premium feel, and effortless style. Every piece is created with attention to detail, offering clothing that feels elegant, comfortable, and modern.",
      bg: "https://api.visko.group/public/assets/img/uploads/ticket-docs/1772089401_b714f2fc8e44e0deaa3d.png",
      logo: "https://viskotextileindustries.com/assets/ViskoTextileLogo-DUCMqMk-.png",
      logoWidth: "140",
      logoHeight: "70",
      projectLogo: "https://api.visko.group/public/assets/img/uploads/ticket-docs/1772084399_5446bb8090a50274ce17.png",
      website: "https://viskotextileindustries.com/",
      isComingSoon: false,
    },
    {
      id: 6,
      name: "Visko HR & IT Solutions LLC",
      name2: "(Dubai)",
      tagline: "Enabling smarter workforces and efficient digital systems for growing organizations.",
      description:
        "Visko HR & IT Solutions LLC offers integrated HR management and IT support services that help businesses operate seamlessly. With an expanding presence in Dubai, UAE, we support organizations in building skilled teams and scalable technology frameworks.",
      bg: "https://api.visko.group/public/assets/img/uploads/ticket-docs/1772089434_8f59aad90a678634230d.png",
      logo: "https://viskohr.ae/static/media/viskohr-logo.7a3dd1fbe4dbe67ae056.webp",
      logoWidth: "155",
      logoHeight: "60",
      projectLogo: "https://api.visko.group/public/assets/img/uploads/ticket-docs/1772084399_5446bb8090a50274ce17.png",
      website: "https://viskohr.ae/",
      isComingSoon: false,
    },
    {
      id: 7,
      name: "Visko Foods Private Limited",
      tagline: "Quality You Can Taste. Trust You Can Feel.",
      description:
        "Visko Foods Pvt. Ltd. is committed to delivering high-quality food products with a strong focus on hygiene, consistency, and customer satisfaction. Every product is crafted with care and industry-standard practices.",
      bg: "https://api.visko.group/public/assets/img/uploads/ticket-docs/1772089469_307791e500b2e25d8b81.png",
      logo: "https://api.visko.group/public/assets/img/uploads/ticket-docs/1772084399_5446bb8090a50274ce17.png",
      logoWidth: "65",
      logoHeight: "65",
      projectLogo: "https://api.visko.group/public/assets/img/uploads/ticket-docs/1772084399_5446bb8090a50274ce17.png",
      website: "https://viskofoods.com/",
      isComingSoon: true,
    },
  ];


  return (
    <div className="container my-5" id="services">

      {/* Heading */}
      <div className="text-center mb-5">
        <h2 className="fw-bold fs-2 fs-lg-1">
          Our Group Companies
        </h2>
        <p className="text-muted fs-5 mt-2">
          A strong ecosystem of businesses, each driven by expertise, trust, and long-term vision.
        </p>
      </div>

      {/* Static Company Cards */}
      {companies.map((company) => (
        <CompanyCard
          key={company.id}
          bg={company.bg}
          logo={company.logo}
          name={company.name}
          name2={company.name2}
          tagline={company.tagline}
          description={company.description}
          projectLogo={company.projectLogo}
          website={company.website}
          logoWidth={company.logoWidth}
          logoHeight={company.logoHeight}
          isComingSoon={company.isComingSoon}
        />
      ))}

    </div>
  );
}